module.exports = new __parcel__URL__("battleroyale_you_are_ready_button.2dbba107.png").toString();